import { useEffect } from 'react';

/** Turns committed server changes into one window event that pages already reload on. */
export function useLiveUpdates(signedIn: boolean) {
  useEffect(() => {
    if (!signedIn) return;
    const source = new EventSource('/app-api/events', { withCredentials: true });
    const changed = () => window.dispatchEvent(new Event('alder:state-changed'));
    source.addEventListener('change', changed);
    // The server lost and regained its change feed; refetch in case a change was missed.
    source.addEventListener('resync', changed);
    return () => {
      source.removeEventListener('change', changed);
      source.removeEventListener('resync', changed);
      source.close();
    };
  }, [signedIn]);
}
